import React from "react";
import {
  Navbar,
  MobileNav,
  IconButton,
} from "@material-tailwind/react";
import Button from "../button/button.component";
import NavList from "./nav-list";

const NavbarComponent = () => {
  const [openNav, setOpenNav] = React.useState(false);

  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false)
    );
  }, []);

  const whatsappMessage = "Hii Tara I want to connect";

  const handleConnect = () => {
    window.open(
      `https://wa.me/+917229804925/?text=${whatsappMessage}`,
      "_blank"
    );
  };

  return (
    <div className="max-h-[768px] w-full overflow-scroll text-white">
      <Navbar className="fixed top-0 z-10 h-max max-w-full rounded-none px-4 py-2 lg:px-8 lg:py-4">
        <div className="flex items-center justify-between">
          <div>
            <img
              src="https://i.ibb.co/4tJbXDK/Screenshot-2024-03-01-at-9-42-57-PM-removebg-preview.png"
              alt="Screenshot-2024-03-01-at-9-42-57-PM"
              className="h-6 lg:h-8"
            />
          </div>
          <div className="flex items-center gap-4">
            <div className="hidden lg:flex items-center gap-x-1">
              <Button onClick={handleConnect}>Get In Touch</Button>
            </div>
            <IconButton
              variant="text"
              className="ml-auto h-6 w-6 text-inherit flex justify-center items-center hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
              ripple={false}
              onClick={() => setOpenNav(!openNav)}
            >
              {openNav ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  className="h-6 w-6"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </IconButton>
          </div>
        </div>
        <MobileNav open={openNav}>
          {NavList}
          <div className="flex items-center gap-x-1">
            <Button onClick={handleConnect}>Get In Touch</Button>
          </div>
        </MobileNav>
      </Navbar>
    </div>
  );
};

export default NavbarComponent;


/* <a href="https://ibb.co/GpFZ81n"><img src="https://i.ibb.co/4tJbXDK/Screenshot-2024-03-01-at-9-42-57-PM-removebg-preview.png" alt="Screenshot-2024-03-01-at-9-42-57-PM-removebg-preview" border="0"></a> */


// <a href="https://imgbb.com/"><img src="https://i.ibb.co/NNdvDkB/Screenshot-2024-03-01-at-9-43-17-PM-removebg-preview.png" alt="Screenshot-2024-03-01-at-9-43-17-PM-removebg-preview" border="0"></a>